import { Row, Col, Spinner } from '@deere/ux.uxframe-react';
import SuppliersEMRTCard from '../../components/extended-mineral/SuppliersEMRTCard';
import DownloadEMRTCard from '../../components/extended-mineral/DownloadEMRTCard';
import UploadEMRTCard from '../../components/extended-mineral/UploadEMRTCard';
import EMRTResponsesCard from '../../components/extended-mineral/EMRTResponsesCard';
import { postEMResponse } from '../../utils/saveSurveyUtils';
import React, { useState, useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { useUserInfo } from '../../providers/userProvider';
import { getEmResponseByAssignmentId, deleteEmResponseByResponseId, removeAssignmentFromResponse } from '../../services/em.service';
import EMTitle from '../../components/extended-mineral/EMSurveyTitle';
import { ErrorCard } from '../../components/ErrorCard';
import CustomAlert from '../../components/CustomAlert';
import { getRequestsInGroup } from '../../services/cm.service';
import { ModalGeneric } from '../../components/ModalGeneric';
import { useTranslation } from "react-i18next";
import { Breadcrumbs, Link, Typography, Button } from "@deere/fuel-react"
import { SCBM_USER_TYPE, SCBM_STATES_CAMPAIGN, EM_ADMIN, LBL_MESSAGE, LBK_OK, MGS_COME_BACK_LATER, LBL_CLOSE } from '../../utils/surveyLiterals';
import { useHistory } from 'react-router';
import CampaignClosedAlert from '../../components/CampaignClosedAlert';

export default function UploadDownloadEMRT({ survey, campaignAssigned }) {
    const { t } = useTranslation();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [loadingBar, setLoadingBar] = useState(false);
    const { authState } = useOktaAuth();
    const userInfo = useUserInfo();
    const [userResponses, setUserResponses] = useState();
    const [errors, setErrors] = useState([]);
    const [latestResponse, setLatestResponse] = useState();
    const [successMessage, setSuccessMessage] = useState(null);
    const [suppliersInGroup, setSuppliersInGroup] = useState();
    const [showValidationModal, setShowValidationModal] = useState(false);
    const [validationMsg, setValidationMsg] = useState("");
    const [responseToDelete, setResponseToDelete] = useState();
    const [showValidationRemoveModal, setShowValidationRemoveModal] = useState(false);
    const [showReminderModalForReview, setShowReminderModalForReview] = useState(false);
    const [showResponseInProcessModal, setShowResponseInProcessModal] = useState(false)
    const [validationRemoveMsg, setValidationRemoveMsg] = useState("");
    const [assignmentToRemove, setAssignmentToRemove] = useState();
    const [fielKey, setFileKey] = useState('');
    const [currentUploadedFile, setCurrentUploadedFile] = useState();
    const actionsEnabled = campaignAssigned.status === SCBM_STATES_CAMPAIGN.OPEN && userInfo.userType !== SCBM_USER_TYPE.SALARY;
    const canRemoveSupplier = campaignAssigned.status === SCBM_STATES_CAMPAIGN.OPEN && userInfo.roles.includes(EM_ADMIN);

    const upload = (file) => {
        if (file && file.length > 0) {
            setFileKey(file[0] ? file[0].name + new Date() : null);
        }
        setLoading(true);
        setLoadingBar(true);
        setSuccessMessage(null);
        postEMResponse(authState.accessToken.accessToken, file, userInfo.userID, campaignAssigned.assignments[0].id, campaignAssigned.id).then((response) => response.json())
            .then(data => {
                if (!data || data.length > 0 || data.statusCode) { //there are error in the response
                    if (!data.statusCode) {
                        setErrors([...data]);
                    } else {
                        setErrors(['Error uploading the file, please contact the support team or try again later.'])
                    }
                    window.scrollTo(0, 0);
                } else {
                    setSuccessMessage('The EMRT file was uploaded successfully');
                    getEmResponseByAssignmentId(campaignAssigned.assignments[0].id, authState.accessToken.accessToken).then(response => {
                        if (response) {
                            setUserResponses([...response]);
                            setShowReminderModalForReview(true);
                            setCurrentUploadedFile({ ...response.filter(i => i.id === data.id)[0], ...data });
                        }
                        setErrors([]);
                    }).catch(error => {
                        console.log(error);
                        setErrors(['Error processing the request'])
                        window.scrollTo(0, 0);
                    })
                }
                setLoading(false);
                setLoadingBar(false);
            }).catch(error => {
                const errorMsg = error ? error.toString() : '';
                if (errorMsg.includes('Failed to fetch') || errorMsg.includes(`SyntaxError: Unexpected token '<', "<!DOCTYPE "... is not valid JSON`)) {
                    setShowResponseInProcessModal(true);
                } else {
                    setErrors(['Error processing the request.'])
                    window.scrollTo(0, 0);
                }

                setLoading(false);
                setLoadingBar(false);
                console.log(error);
            });
    }

    useEffect(() => {
        if (!userResponses && campaignAssigned && campaignAssigned.assignments && campaignAssigned.assignments.length > 0) {
            loadResponses()
        }
    }, [authState.accessToken.accessToken, campaignAssigned, userResponses]);

    useEffect(() => {
        if (!suppliersInGroup && campaignAssigned && campaignAssigned.assignments && campaignAssigned.assignments.length > 0) {
            getRequestsInGroup(campaignAssigned.assignments[0].supplierNumber, campaignAssigned.id, authState.accessToken.accessToken)
                .then((resRequestsInGroup) => {
                    if (resRequestsInGroup && resRequestsInGroup.length > 0) {
                        //Filtering by groupNumber
                        const tmpSupplierInGroup = resRequestsInGroup.filter(tmpRequestInGroup => tmpRequestInGroup.groupNumber === campaignAssigned.assignments[0].groupNumber)
                        setSuppliersInGroup([...tmpSupplierInGroup]);
                    } else {
                        setSuppliersInGroup([campaignAssigned.assignments[0]]);
                    }
                }).catch(error => {
                    console.log(error);
                    setErrors(['Error processing the request'])
                })
        }
    }, [authState.accessToken.accessToken, campaignAssigned, suppliersInGroup]);

    const loadResponses = () => {
        setSuccessMessage(null);

        getEmResponseByAssignmentId(campaignAssigned.assignments[0].id, authState.accessToken.accessToken).then(response => {
            if (response && response.length > 0) {
                setUserResponses([...response]);

                setLatestResponse(response[0]);

            }
        }).catch(error => {
            setErrors(['Error processing the request'])
        })
    }

    const handleDeleteResponse = () => {
        try {
            deleteEmResponseByResponseId(responseToDelete, authState.accessToken.accessToken).then((response) => {
                if (response && response.numberResponsesDeleted && response.numberResponsesDeleted > 0) {
                    setSuccessMessage('The response was deleted succesfully');
                    const tmpUserResponses = userResponses.filter(response => response.id !== responseToDelete);
                    setUserResponses(tmpUserResponses);
                    setSuppliersInGroup(null);
                } else {
                    if (successMessage) { setSuccessMessage(null) }
                    setErrors(['Error deleting the response, please refresh the page and try again.']);
                }
            })
        } catch (error) {
            console.log(error);
            setErrors([error]);
        }
        setResponseToDelete(null)
        setValidationMsg("");
        setShowValidationModal(false);
        goToTop();
        return true;
    };

    const handleRemoveSupplier = () => {
        try {
            removeAssignmentFromResponse(assignmentToRemove, authState.accessToken.accessToken).then((responseRemove) => {
                if (responseRemove && responseRemove.numberAssignmentsUpdated && responseRemove.numberAssignmentsUpdated > 0) {
                    setSuccessMessage('The supplier was removed succesfully');
                    const tmpSuppliersInGroup = suppliersInGroup.filter(suppliersInGroup => suppliersInGroup.id !== assignmentToRemove);
                    setSuppliersInGroup(tmpSuppliersInGroup);

                } else {
                    setErrors(['Error removing supplier from group, please refresh the page and try again.']);
                }
            })
        } catch (error) {
            console.log(error);
            setErrors([error]);
        }
        setAssignmentToRemove(null)
        setShowValidationRemoveModal(false);
        return true;
    };

    const showDeleteValidation = (responseId) => {
        window.scrollTo(0, 0);
        let suppliersInResponse = suppliersInGroup.map(tmpSupplierInGroup => {
            return tmpSupplierInGroup.supplierNumber;
        })
        setValidationMsg("Are you sure you want to delete this response? \n Response No. " + responseId + " \n Supplier(s): " + suppliersInResponse);
        setResponseToDelete(responseId)
        setShowValidationModal(true);
    }

    const showRemoveValidation = (supplierInGroup) => {
        setValidationRemoveMsg("Are you sure you want to remove this supplier from the group? \n Supplier No. " + supplierInGroup.supplierNumber + " \n Request: " + supplierInGroup.id);
        setAssignmentToRemove(supplierInGroup.id)
        setShowValidationRemoveModal(true);
    }

    const goToTop = () => {
        window.scrollTo(0, 0);
    }

    const review = () => {
        history.push({
            pathname: '/em/review',
            state: {
                previous: '/em',
                assignmentId: campaignAssigned.assignments[0].id,
                responseId: currentUploadedFile.id,
                survey: survey
            }
        })
    }

    return (<div>
        <Row>
            <Col md="24" className="card-body p-3 text-left">
                <Breadcrumbs>
                    <Link href="/">Search</Link>
                    <Typography color="textPrimary">{survey.code}</Typography>
                </Breadcrumbs>
                <EMTitle survey={survey} assignment={campaignAssigned.assignments[0]} latestResponse={latestResponse} showReviewSuggestion={false} />
            </Col>
        </Row>
        <Row>
            <Col xs={24} md={24}>
                <CampaignClosedAlert campaign={campaignAssigned} />
                {
                    errors.length > 0 ? <ErrorCard errors={errors} title={'Please fix the listed errors and try again.'} /> : null
                }
                {
                    successMessage ?
                        <CustomAlert accessibilityLabel='success' variant='success' title={successMessage} />
                        : null
                }
                {!suppliersInGroup && <Spinner style={{ margin: 'auto' }} animation="border" role="status"><span className="visually-hidden"></span>
                </Spinner>}
                {suppliersInGroup && <SuppliersEMRTCard index={"1."} loading={loading} assignmentId={campaignAssigned.assignments[0].id} handleRemoveFn={showRemoveValidation} suppliersInGroup={suppliersInGroup} canRemove={canRemoveSupplier} campaign={campaignAssigned}/>}
                <br />
                {suppliersInGroup && <DownloadEMRTCard assignmentId={campaignAssigned.assignments[0].id} surveyId={survey.id} loading={loading} setLoading={setLoading} />}
                <br />
                {suppliersInGroup && <UploadEMRTCard loadingBar={loadingBar} loading={loading} upload={upload} fielKey={fielKey} status={campaignAssigned.assignments[0].status} />}
                <br />
                {suppliersInGroup && <EMRTResponsesCard loading={loading} userResponses={userResponses} survey={survey} handleDeleteFn={showDeleteValidation} suppliersInGroup={suppliersInGroup}
                    currentAssignmentId={campaignAssigned.assignments[0].id} loadResponses={loadResponses} actionsEnabled={(actionsEnabled || canRemoveSupplier)} campaign={campaignAssigned} />
                }
                <br />
            </Col>
        </Row>
        <ModalGeneric showModal={showValidationModal}
            setShowModal={setShowValidationModal}
            labelBtnPrimary={t('t2_remove')}
            labelBtnSecondary={t('btn_cancel')}
            handleSubmit={handleDeleteResponse}
            msgModal={validationMsg}
            titleModal={t('t2_remove')}
        />
        <ModalGeneric showModal={showValidationRemoveModal}
            setShowModal={setShowValidationRemoveModal}
            labelBtnPrimary={t('t2_remove')}
            labelBtnSecondary={t('btn_cancel')}
            handleSubmit={handleRemoveSupplier}
            msgModal={validationRemoveMsg}
            titleModal={t('t2_remove')}
        />
        <ModalGeneric showModal={showReminderModalForReview}
            setShowModal={setShowReminderModalForReview}
            labelBtnPrimary={t('btn_review_or_submit')}
            labelBtnSecondary={t('btn_cancel')}
            handleSubmit={review}
            msgModal={t('review_and_submit_message', { count1: currentUploadedFile?.declaredPartsMatchingWithRequested, count2: currentUploadedFile?.totalRequestedParts })}
            titleModal={t('btn_review')}
        />
        <ModalGeneric showModal={showResponseInProcessModal}
            setShowModal={setShowResponseInProcessModal}
            labelBtnPrimary={LBK_OK}
            labelBtnSecondary={LBL_CLOSE}
            handleSubmit={() => setShowResponseInProcessModal(false)}
            msgModal={MGS_COME_BACK_LATER}
            titleModal={LBL_MESSAGE}
        />
        <div className="position-sticky fixed-bottom" style={{ textAlign: "right" }}>
            <Button variant="secondary" onClick={goToTop}>
                <svg focusable="false" aria-hidden="true" fill="#666" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                    <path d="M0 0h24v24H0V0z" fill="none"></path>
                    <path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"></path>
                </svg>Top
            </Button>
        </div>
    </div>
    );
}